import ApplyForm from '../components/ApplyForm';
import toggleLearnMore from '../actions/toggleLearnMore';

/**
 * Application Form Page
 */
const PageApply =( $ )=>{

	if ( $( 'body' ).hasClass( 'page-template-apply' ) ) {
		ApplyForm( $ );
		toggleLearnMore( $ );
	}

};

export default PageApply;
